import React from "react";
import styles from "./Title.module.scss";

const Title = ({ text, bottomStrokeWidth }) => {
  return (
    <div className={styles.title}>
      <h1>
        <span className={styles.leftStroke} /> {text}
        <span
          className={styles.bottomStroke}
          style={{ width: bottomStrokeWidth }}
        />
      </h1>
    </div>
  );
};

export default Title;
